/* FRAME v10 — progressive-enhanced filtering and Shopify predictive search. */
(()=>{
  'use strict';
  document.documentElement.classList.add('frame-js');
  let requestController=null;
  let requestIndex=0;
  const filteredURL=(form)=>{
    const url=new URL(form.action,window.location.href);
    url.search='';
    new FormData(form).forEach((value,key)=>{
      if(typeof value==='string'&&value.trim()!=='')url.searchParams.append(key,value);
    });
    return url;
  };
  const renderListing=async(url,{push=true,restoreFacet=null,restoreMobile=false}={})=>{
    const root=document.querySelector('[data-frame-discovery]');
    if(!root){window.location.assign(url.href);return;}
    const sectionId=root.getAttribute('data-frame-section-id');
    if(!sectionId){window.location.assign(url.href);return;}
    if(requestController)requestController.abort();
    const currentIndex=++requestIndex;
    const controller=new AbortController();requestController=controller;
    const queryURL=new URL(url.href);
    queryURL.searchParams.set('section_id',sectionId);
    const openFacets=[...root.querySelectorAll('[data-frame-facet][open]')].map(el=>el.dataset.frameFacet);
    if(!restoreFacet&&restoreMobile)restoreFacet=openFacets;
    root.classList.add('is-loading');
    root.querySelector('[data-frame-results]')?.setAttribute('aria-busy','true');
    const status=root.querySelector('[data-frame-discovery-status]');
    if(status)status.textContent='Updating products';
    try{
      const response=await fetch(queryURL.toString(),{signal:controller.signal,credentials:'same-origin',headers:{'Accept':'text/html'}});
      if(!response.ok)throw new Error('Section request failed');
      const html=await response.text();
      if(currentIndex!==requestIndex)return;
      const parsed=new DOMParser().parseFromString(html,'text/html');
      const updated=parsed.querySelector(`[data-frame-discovery][data-frame-section-id="${CSS.escape(sectionId)}"]`);
      if(!updated)throw new Error('Discovery section not returned');
      const persist=restoreFacet || openFacets;
      updated.querySelectorAll('[data-frame-facet]').forEach(el=>{
        if(persist.includes(el.dataset.frameFacet))el.open=true;
      });
      if(restoreMobile||root.querySelector('[data-frame-facets]')?.open){
        const mobile=updated.querySelector('[data-frame-facets]');if(mobile)mobile.open=true;
      }
      updated.querySelectorAll('[data-reveal]').forEach(el=>el.classList.add('is-visible'));
      root.replaceWith(updated);
      if(push)history.pushState({frameDiscovery:true},'',url.toString());
      const nextStatus=updated.querySelector('[data-frame-discovery-status]');
      const count=updated.querySelector('[data-frame-count]')?.textContent?.trim()||'Products updated';
      if(nextStatus)nextStatus.textContent=count;
      updated.querySelector('[data-frame-results]')?.setAttribute('aria-busy','false');
    }catch(error){
      if(error.name==='AbortError')return;
      window.location.assign(url.href); // Progressive fallback: Shopify handles normal filtering.
    }finally{
      if(currentIndex===requestIndex){
        const live=document.querySelector('[data-frame-discovery]');live?.classList.remove('is-loading');
        live?.querySelector('[data-frame-results]')?.setAttribute('aria-busy','false');
      }
    }
  };
  document.addEventListener('submit',event=>{
    const form=event.target.closest?.('[data-frame-filter-form]');
    if(!form)return;
    if(!('fetch' in window)||!('DOMParser' in window))return;
    event.preventDefault();
    const root=form.closest('[data-frame-discovery]');
    const active=root?.querySelector('[data-frame-facets]');
    renderListing(filteredURL(form),{restoreMobile:!!active?.open});
  });
  document.addEventListener('change',event=>{
    const select=event.target.closest?.('[data-frame-sort]');
    if(!select)return;
    if(select.form){
      if(select.form.requestSubmit)select.form.requestSubmit();
      else select.form.submit();
    }
  });
  document.addEventListener('click',event=>{
    if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const anchor=event.target.closest?.('[data-frame-discovery] [data-frame-filter-link], [data-frame-discovery] .pagination a');
    if(!anchor||anchor.target||anchor.hasAttribute('download'))return;
    const url=new URL(anchor.href,location.href);
    if(url.origin!==location.origin||url.pathname!==location.pathname)return;
    event.preventDefault();
    const root=anchor.closest('[data-frame-discovery]');
    renderListing(url,{restoreMobile:!!root?.querySelector('[data-frame-facets]')?.open});
  });
  window.addEventListener('popstate',()=>{
    const root=document.querySelector('[data-frame-discovery]');
    if(root)renderListing(new URL(location.href),{push:false});
  });
  const initSearch=(panel)=>{
    if(!panel||panel.dataset.frameSearchReady==='1')return;
    const header=panel.closest('.site-header');
    const toggle=header?.querySelector('[data-frame-search-toggle]');
    const closeButton=panel.querySelector('[data-frame-search-close]');
    const input=panel.querySelector('[data-frame-predictive-input]');
    const results=panel.querySelector('[data-frame-predictive-results]');
    const hint=panel.querySelector('[data-frame-predictive-hint]');
    const allLink=panel.querySelector('[data-frame-predictive-all]');
    const form=panel.querySelector('[data-frame-predictive-form]');
    if(!toggle||!closeButton||!input||!results||!allLink||!form)return;
    panel.dataset.frameSearchReady='1';
    let controller=null,timer=null,selected=-1;
    const getItems=()=>[...results.querySelectorAll('[role="option"]')];
    const setSelected=index=>{
      const items=getItems();selected=Math.min(Math.max(index,-1),items.length-1);
      items.forEach((item,i)=>item.setAttribute('aria-selected',String(i===selected)));
      if(selected>=0){input.setAttribute('aria-activedescendant',items[selected].id);items[selected].scrollIntoView({block:'nearest'});}
      else input.removeAttribute('aria-activedescendant');
    };
    const clear=()=>{results.replaceChildren();results.hidden=true;allLink.hidden=true;input.setAttribute('aria-expanded','false');setSelected(-1);};
    const close=({restoreFocus=false}={})=>{
      if(timer)clearTimeout(timer);if(controller)controller.abort();
      panel.hidden=true;toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-label','Open search');
      clear();if(restoreFocus)toggle.focus();
    };
    const open=()=>{panel.hidden=false;toggle.setAttribute('aria-expanded','true');toggle.setAttribute('aria-label','Close search');input.focus();};
    const makeText=(tag,className,text)=>{
      const node=document.createElement(tag);node.className=className;node.textContent=text;return node;
    };
    const showSuggestions=products=>{
      clear();
      if(!products.length){hint.textContent='No matching products. Try another term.';return;}
      const fragment=document.createDocumentFragment();
      products.forEach((product,index)=>{
        const li=document.createElement('li');li.className='frame-predictive__option';li.setAttribute('role','option');
        li.setAttribute('aria-selected','false');li.id=`FramePredictiveOption-${panel.id}-${index}`;
        const link=document.createElement('a');link.className='frame-predictive__item';
        let href;
        try{href=new URL(product.url,window.location.origin);}
        catch{return;}
        if(href.origin!==window.location.origin)return;
        link.href=href.href;
        const media=makeText('span','frame-predictive__media','');
        const imageURL=product.featured_image?.url||product.image;
        if(typeof imageURL==='string'&&/^https?:\/\//i.test(imageURL)){
          const img=document.createElement('img');img.src=imageURL;img.loading='lazy';img.alt='';media.append(img);
        }
        const details=makeText('span','frame-predictive__details','');
        details.append(makeText('span','frame-predictive__item-title',product.title||'Product'));
        if(product.type)details.append(makeText('span','frame-predictive__item-type',product.type));
        link.append(media,details,makeText('span','frame-predictive__item-action','View →'));
        li.append(link);fragment.append(li);
      });
      results.append(fragment);
      results.hidden=false;allLink.hidden=false;input.setAttribute('aria-expanded','true');
      hint.textContent=`${getItems().length} product suggestions. Use arrow keys to choose.`;
    };
    const search=async()=>{
      const query=input.value.trim();
      if(controller)controller.abort();
      clear();
      if(query.length<2){hint.textContent='Enter at least two characters to see suggestions.';return;}
      const next=new AbortController();controller=next;
      hint.textContent='Searching products…';
      const url=new URL(panel.dataset.framePredictiveUrl||'/search/suggest.json',location.origin);
      url.searchParams.set('q',query);url.searchParams.set('resources[type]','product');
      url.searchParams.set('resources[limit]','6');url.searchParams.set('resources[options][unavailable_products]','last');
      const all=new URL(form.action,location.origin);all.searchParams.set('q',query);all.searchParams.set('type','product');
      allLink.href=all.href;
      try{
        const response=await fetch(url,{credentials:'same-origin',signal:next.signal,headers:{'Accept':'application/json'}});
        if(!response.ok)throw new Error(`Search unavailable: ${response.status}`);
        const data=await response.json();
        if(input.value.trim()!==query)return;
        showSuggestions(data?.resources?.results?.products||[]);
      }catch(error){
        if(error.name==='AbortError')return;
        hint.textContent='Suggestions are unavailable. Press Search for full results.';
        clear();
      }
    };
    toggle.addEventListener('click',()=>{if(panel.hidden)open();else close({restoreFocus:true});});
    closeButton.addEventListener('click',()=>close({restoreFocus:true}));
    input.addEventListener('input',()=>{if(timer)clearTimeout(timer);timer=setTimeout(search,220);});
    input.addEventListener('keydown',event=>{
      const items=getItems();
      if(event.key==='Escape'){event.preventDefault();close({restoreFocus:true});return;}
      if(!items.length)return;
      if(event.key==='ArrowDown'){event.preventDefault();setSelected((selected+1)%items.length);}
      if(event.key==='ArrowUp'){event.preventDefault();setSelected(selected<=0?items.length-1:selected-1);}
      if(event.key==='Enter'&&selected>=0){event.preventDefault();const a=items[selected].querySelector('a');if(a)location.assign(a.href);}
    });
    panel.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();close({restoreFocus:true});}});
    document.addEventListener('click',event=>{
      if(!panel.hidden&&!panel.contains(event.target)&&!toggle.contains(event.target))close();
    });
  };
  document.querySelectorAll('[data-frame-predictive]').forEach(initSearch);
  document.addEventListener('shopify:section:load',event=>{
    event.target.querySelectorAll('[data-frame-predictive]').forEach(initSearch);
  });
})();
